import(/* webpackMode: "eager" */ "/app/src/app/language/[code]/hanzi/page.tsx");
